<template>
    <div id="IndexInfo">
        <div class="banner">
            <!-- <video src="../../assets/video/banner-animate.mp4" muted autoplay loop>
                您的浏览器不支持 video 标签。
            </video> -->
             <el-carousel trigger="click" :height="carHeight">
                <el-carousel-item v-for="(item, idx) in bannerList" :key="idx">
                    <img :src="item.img" alt="" ref="img">
                </el-carousel-item>
            </el-carousel>
            <div class="weather">
                <div class="weather-header">
                  <el-popover
                    placement="bottom"
                    title=""
                    trigger="hover"
                    :visible-arrow='false'
                    popper-class="weath-class"
                   >
                    <div class="weather-con">
                      <div class="weather-con-list" v-for="(weatherList,index) in weather" :key="index">
                        <div class="weather-name" v-if="index==0">今天</div>
                        <div class="weather-name" v-if="index==1">明天</div>
                        <div class="weather-name" v-if="index==2">后天</div>
                        <div class="weather-date">{{ weatherList.date }}</div>
                        <div class="weather-ico"><img :src="weatherIco(weatherList.cond_txt_d)" alt=""></div>
                        <div class="weather-text">{{ weatherList.cond_txt_d }}</div>
                        <div class="weather-tem">{{ weatherList.tmp_min }}℃~{{ weatherList.tmp_max }}℃</div>
                        <div class="weather-wind">{{ weatherList.wind_dir }}{{ weatherList.wind_sc }}级</div>
                      </div>
                    </div>
                    <ul class="weather-h-item"  slot="reference" >
                      <li><img src="../../assets/img/newIndex/loc.png" class="loc-ico">{{city.deptName}}</li>
                      <li v-if="weather.length>0">{{ weather[0] ? weather[0].tmp_min:0 }}~{{ weather[0] ? weather[0].tmp_max:0 }}℃</li>
                      <li v-if="weather.length>0"><img v-if="weather[0]" :src="weatherIco(weather[0].cond_txt_d)" alt=""></li>
                      <li v-if="weather.length>0">{{weather[0] ? weather[0].wind_dir:""}}</li>
                      <li>
                        <span>适宜海钓</span>
                        <template v-for="starList in compuStar" >
                          <img src="../../assets/img/newIndex/star.png" alt="" :key="starList" class="star-list">
                        </template>
                      </li>
                    </ul>
                  </el-popover>
                </div>
            </div>
            <div class="hot-info">
              <h3>热门信息</h3>
                <div class="hot-info-box" style="height:100%">
                  <el-scrollbar style="height:100%">
                    <div class="hot-info-list" v-for="(item,index) in hotInfo" :key="index">
                      <router-link :to="{path:`/InfoDetails?id=${item.id}&type=xuan`}">
                         {{item.title}}
                      </router-link>
                    </div>
                  </el-scrollbar>
                </div>
            </div>
        </div>
        <div class="index-content">
          <!-- 海钓活动  -->
            <div class="sea-fishing">
              <h3 class="com-header">
                <img src="../../assets/img/newIndex/seaFishing.png" alt="">
              </h3>
              <div class="sea-con">
                <div class="sea-con-list" v-for="(seaItem,idx) in seaFishing" :key="idx">
                  <router-link :to="{path:`/InfoDetails?id=${seaItem.id}&type=xuan`}">
                    <img :src="seaItem.fileUrl" alt="">
                    <div class="sea-con-list-title">
                      {{seaItem.title}}
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="more">
                <router-link to="/FishInfo?type=2">
                  查看更多
                </router-link>
              </div>
            </div>
            <!-- 海钓视频 -->
            <div class="sea-video">
              <h3 class="sea-video-header">
                <img src="../../assets/img/newIndex/sea-video.png" alt="">
              </h3>
              <div class="sea-video-con">
                <div class="sea-video-con-left"  @click="videoPlayFun($event,1)">
                  <video ref="seaVideoRef" :src="seaVideoMain.videoUrl"   :poster="seaVideoMain.imgUrl"></video>
                  <img src="../../assets/img/newIndex/play-big.png" v-show ="seaVideoMain.videoPlay" alt=""  class="play-btn">
                </div>
                 <div class="sea-video-con-right"  v-if="seaVideo.length>0">
                   <div v-for="(seaItem,idx) in seaVideo" :key="idx" class="sea-video-con-box"  @click="videoPlayFun($event,2,idx)">
                      <video :src="seaItem.videoUrl" :poster="seaItem.imgUrl"></video>
                       <img src="../../assets/img/newIndex/play-small.png" v-show ="seaItem.videoPlay" alt="" class="play-btn">
                   </div>
                   <div class="video-more">
                     <router-link to="/Strategy?type=1">
                       <img v-if="seaVideo[0].imgUrl" src="../../assets/img/more.png" alt="">
                        <span>查看更多</span>
                     </router-link>
                   </div>
                </div>
                <div class="sea-video-bottom">
                  <div class="sea-video-b-left" v-if="seaVideo[0]">
                    <div class="sea-video-b-c">
                       <h3>海底世界</h3>
                       <div>这个夏天，一起潜入美高梅海底世界，欣赏最具创意的空中海洋秀！在美狮美高梅的视博广场下，观看飞天海豚畅游，并在全球面积最大的室内LED屏幕下欣赏不同的深海奇景，让您犹如置身神秘海洋中！此外，您更可在淳、盛焰及视博茶点享受精致佳肴及糕点，让您的假期丰富多彩。</div>
                    </div>
                  </div>
                  <div class="sea-video-b-right">
                    <div v-if="seaVideo[0]" class="sea-video-b-right-b"  >
                      <video src="../../assets/img/video/hdsj.mp4" controls ></video>
                      <!-- <img  src="../../assets/img/newIndex/play-small.png" v-show="seaVideo[0].videoPlay" alt="" class="play-btn"> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 海钓渔获 -->
            <div class="sea-get">
               <h3 class="com-header">
                <img src="../../assets/img/newIndex/sea-get.png" alt="">
              </h3>
              <div class="sea-get-con">
                <div class="sea-get-list" v-for="(seaItem,idx) in seaGet" :key="idx">
                  <router-link :to="{path:`/InfoDetails?id=${seaItem.id}&type=see`}">
                    <img :src="seaItem.imgUrl" alt="">
                    <div class="sea-con-list-title">
                      {{seaItem.title}}
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="more">
                <router-link to="/Strategy?type=8">
                  查看更多
                </router-link>
              </div>
            </div>
            <!-- 海钓咨询 -->
            <div class="sea-advisory">
              <h3 class="sea-advisory-header">
                <img src="../../assets/img/newIndex/sea-advisory.png" alt="">
              </h3>
              <div class="sea-advisory-con">
                <div class="sea-advisory-left">
                  <router-link :to="{path:`/InfoDetails?id=${seaFashingInfoItem.id}&type=xuan`}"  v-for="(seaFashingInfoItem,index) in seaFishingInfo" :key="index">
                    <div class="sea-advisory-left-list">
                        <div class="sea-list-date">
                          <div class="sea-date-month sea-date-com">
                            {{seaFashingInfoItem.addTime.split(" ")[0].split("-")[1]}}月
                          </div>
                          <div class="sea-date-date sea-date-com">
                              {{seaFashingInfoItem.addTime.split(" ")[0].split("-")[2]}}日
                          </div>
                        </div>
                        <div class="sea-list-content">
                          {{seaFashingInfoItem.profile}}
                        </div>
                        <div class="sea-list-btn">&gt;&gt;</div>
                    </div>
                  </router-link>
                </div>
                <div class="sea-advisory-right">
                   <img v-if="seaFishingInfo[0]" :src="seaFishingInfo[0].fileUrl" alt="">
                </div>
              </div>
              <div class="more">
                <router-link to="/FishInfo?type=1">
                  查看更多
                </router-link>
              </div>
            </div>
              <!-- 海钓常识 -->
            <div class="sea-sense">
              <div class="sea-sense-con">
                <h3>海钓常识</h3>
                <div class="line"></div>
                <div class="sea-sense-con-list" v-for="(seaSenseItem, index) in seaSense" :key="index">
                  <router-link :to="{path:`/InfoDetails?id=${seaSenseItem.id}&type=xuan`}" style="color:#000">
                    <div class="sea-sense-title">
                      {{seaSenseItem.profile}}
                    </div>
                    <div class="sea-sense-time">
                      {{seaSenseItem.addTime.split(" ")[0]}}
                    </div>
                  </router-link>
                </div>
                <div class="more">
                  <router-link to="/FishInfo?type=3">
                    查看更多 》
                  </router-link>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import eventBus from '../../assets/js/event_bus'
    import { mapGetters } from 'vuex'

    export default {
        name: 'IndexInfo',
        data() {
            return {
                // 地区
                areaList: ['青岛', '济南'],
                carHeight: '500px', // 轮播图高度
                bannerList: [{
                    img: require('../../assets/img/newIndex/banner1.jpg')
                }, {
                    img: require('../../assets/img/newIndex/banner2.jpg')
                }, {
                    img: require('../../assets/img/newIndex/banner3.jpg')
                }, {
                    img: require('../../assets/img/newIndex/banner4.jpg')
                }],
                // 测试列表
                commodityList: [
                    {
                        banner: require('../../assets/img/pic1.png'),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        value: '¥290'
                    },
                    {
                        banner: require('../../assets/img/pic2.png'),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题11111111',
                        value: '¥290'
                    },
                    {
                        banner: require('../../assets/img/pic3.png'),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        value: '¥290'
                    }
                ],
                // 测试列表
                testList: [
                    {
                        banner: require(`../../assets/img/pic1.png`),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        subtitle: '舟山海岛海洋资源丰富，有着发展旅游的得天独厚条件。 2016年11月，舟山被国家旅游局列为国家全域旅游示范区创建单位，提出“全景舟山”建设目标，全面推进海岛城乡景区化建设。',
                        time: '2020-2-24'
                    },
                    {
                        banner: require(`../../assets/img/pic3.png`),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题',
                        subtitle: '舟山海岛海洋资源丰富，有着发展旅游的得天独厚条件。 2016年11月，舟山被国家旅游局列为国家全域旅游示范区创建单位，提出“全景舟山”建设目标，全面推进海岛城乡景区化建设。',
                        time: '2020-2-24'
                    },
                    {
                        banner: require(`../../assets/img/pic2.png`),
                        title: '如何立足优势、深挖特色，是舟山旅游一直思考的问题aaaaaaaaaa',
                        subtitle: '舟山海岛海洋资源丰富，有着发展旅游的得天独厚条件。 2016年11月，舟山被国家旅游局列为国家全域旅游示范区创建单位，提出“全景舟山”建设目标，全面推进海岛城乡景区化建设。',
                        time: '2020-2-24'
                    }
                ],
                // 宣的按钮
                xuanBtn: [
                    {name: '海钓资讯'},
                    {name: '比赛信息'},
                    {name: '海钓常识'}
                ],
                // 按钮列表
                fuBtn: {
                    海钓公司: [
                        {name: '运营资质'},
                        {name: '违法处理'},
                        {name: '保险投保'},
                        {name: '金融贷款'}
                    ],
                    游客: [
                        {name: '海钓证申请'},
                        {name: '一键救援'},
                        {name: '投诉举报'},
                        {name: '人工咨询'},
                        {name: '酒店预约'}
                    ]
                },
                // footer 列表
                footerList: [
                    {name: '友情链接'},
                    {name: '友情链接'},
                    {name: '友情链接'},
                    {name: '友情链接'},
                    {name: '友情链接'}
                ],
                // 热门栏列表
                navList: [
                    {name: '首页', path: ''},
                    {name: '海钓资讯', path: ''},
                    {name: '海钓预约', path: ''},
                    {name: '海钓攻略', path: ''},
                    {name: '钓场信息', path: ''},
                    {name: '装备租买', path: ''},
                    {name: '海钓风采', path: ''},
                    {name: '活动比赛', path: ''},
                    {name: '海钓论坛', path: ''}
                ],
                // 天气对象
                weather: [],
                // 宣传列表
                xuanNav: [],
                // 宣传信息
                xuanInfo: [],
                // 看的字段
                seeNav: [],
                // 宣得字段
                pageNum: '1',
                pageSize: '5',
                xuanType: '',
                // 看的字段
                // 看的页码
                seePageNum: '1',
                // 看的页面多少
                seePageSize: '9',
                // 看的类型
                seeType: '',
                // see的主要对象
                seeMain: '',
                // see 的主要信息
                seeInfo: '',
                // 推荐信息
                recommendList: '',
                // 热门信息
                hotInfo: [],
                // 海钓活动
                seaFishing: [],
                // 海钓咨询
                seaFishingInfo: [],
                // 海钓视频
                seaVideo: [],
                // 海钓视频高度
                seaVideoHeight: 0,
                seaVideoMain: {},
                // 海钓渔获
                seaGet: [],
                // 海钓常识
                seaSense: []
            }
        },
        computed: {
          ...mapGetters({
              city: 'getCity'
          }),
          compuStar() {
           let weather = this.weather
            let num = 1
            if (weather[0]) {
             num = weather[0].cond_txt_d === '晴' ? 5 : 3
            }
            return num
          }
        },
        methods: {
            /**
             * 切换tab
             */
            changeTab(item) {
                this.xuanType = item.dictValue
                this.getXuanInfo()
            },
            /**
             * 宣传的tab
             */
            changeSeeTab(item) {
                this.seeType = item.dictValue
                this.getSeeInfo()
            },
            // navTo(item) {
            //
            // },
            /**
             * 获得天气
             */
            getWeather() {
                // let arr = ['最好', '较好', '中等', '较差', '极差']
                this.$common.extranetGet('https://free-api.heweather.net/s6/weather/forecast', {
                    location: this.city.deptName,
                    key: '8b0b1c529d6f4ad69908f9fa2f7db4b4'
                }).then(res => {
                    this.weather = res.data.HeWeather6[0].daily_forecast || []
                    // this.weather[0].cond_txt_d
                })
            },
            /**
             * 宣传的类型
             */
            getXuanType() {
                this.$common.querystringifyPost('/hdweb/common/getDictByType', {
                    type: 'propagate_type'
                }).then(res => {
                    this.xuanNav = res.data
                })
            },
            /**
             * 宣传的详情
             */
            getXuanInfo(type, size) {
                this.$common.querystringifyPost('/hdweb/portal/getPropagateInfo', {
                    pageNum: this.pageNum,
                    pageSize: size,
                    type: type
                }).then(res => {
                   switch (type) {
                    case 1: this.seaFishingInfo = res.data.rows; break
                    case 2: this.seaFishing = res.data.rows; break
                    case 3: this.seaSense = res.data.rows; break
                    case 4: this.hotInfo = res.data.rows; break
                   }
                })
            },
            /**
             * 获得看的类型
             */
            getSeeType() {
                this.$common.querystringifyPost('/hdweb/common/getDictByType', {
                    type: 'posting_type'
                }).then(res => {
                    this.seeNav = res.data
                })
            },
            /**
             * see 的详情
             */
            getSeeInfo(type, pageSize) {
                this.$common.querystringifyPost('/hdweb/portal/getPosting', {
                    pageNum: this.seePageNum,
                    pageSize: pageSize,
                    type: type
                }).then(res => {
                    switch (type) {
                      case 1: res.data.data.forEach(ele => {
                                 ele.videoPlay = true
                                 return ele
                              })
                              this.seaVideo = res.data.data
                              if (this.seaVideo.length > 0) {
                                this.seaVideoMain = this.seaVideo.splice(0, 1)[0]
                              } break
                      case 8: this.seaGet = res.data.data; break
                      case 9: this.hotInfo = res.data.data; break
                    }
                   // this.seeInfo = res.data.rows
                })
            },
            /**
             * 跳转详情 info的详情
             */
            toDetails(item) {
                this.$router.push({
                    path: '/InfoDetails',
                    query: {
                        id: item.id,
                        type: 'xuan'
                    }
                })
            },
            /**
             * 跳转详情 看的详情
             */
            toSeeDetails(item) {
                this.$router.push({
                    path: '/InfoDetails',
                    query: {
                        id: item.id,
                        type: 'see'
                    }
                })
            },
            /**
             * 切换vedio的状态 开关
             */
            changeVideoStatus(event, mouseStatus) {
                let e = event || window.event
                if (mouseStatus === 'enter') {
                    e.target.play()
                } else if (mouseStatus === 'leave') {
                    e.target.pause()
                }
            },
            /**
             * 获得推荐
             */
            getRecommend() {
                this.$common.querystringifyPost('/hdweb/portal/getPropagateInfoRecomm', {
                    recommend: '1',
                    pageNum: '1',
                    pageSize: '8'
                }).then(res => {
                    this.recommendList = res.data.rows
                })
            },
            addListenEventBus() {
                eventBus.$on('changeCity', () => {
                  this.getWeather()
                  this.getXuanType()
                  // 获取热门信息
                  this.getXuanInfo(4, 10)
                  // 获取海钓活动活动
                  this.getXuanInfo(2, 6)
                  this.getSeeType()
                  // 海钓视频
                  this.getSeeInfo(1, 9)
                  // 海钓渔获
                  this.getSeeInfo(8, 6)
                  // 海钓咨询
                  this.getXuanInfo(1, 3)
                  this.getRecommend()
                  this.addListenEventBus()
                  // 海钓常识
                  this.getXuanInfo(3, 6)
                })
            },
            videoPlayFun(obj, type, idx) {
             let videoObject = obj.currentTarget.firstElementChild
             if (videoObject.paused) {
               videoObject.play()
               if (type === 1) {
                  this.seaVideoMain.videoPlay = false
                } else {
                  this.seaVideo[idx].videoPlay = false
                }
             } else {
               videoObject.pause()
                if (type === 1) {
                  this.seaVideoMain.videoPlay = true
                } else {
                  this.seaVideo[idx].videoPlay = true
                }
             }
            //  if (type === 1) {
            //   this.seaVideoMain.videoPlay = !this.seaVideoMain.videoPlay
            //  } else {
            //   this.seaVideo[idx].videoPlay = !this.seaVideo[idx].videoPlay
            //  }
            // this.$refs[`${refParam}`].play()
            },
            weatherIco(text) {
              if (text === '晴') {
                return require('../../assets/img/newIndex/weather/qing.png')
              } else if (text.indexOf('雷') !== -1) {
                return require('../../assets/img/newIndex/weather/lei.png')
              } else if (text.indexOf('雾') !== -1) {
                return require('../../assets/img/newIndex/weather/wu.png')
              } else if (text.indexOf('雨加雪') !== -1) {
                return require('../../assets/img/newIndex/weather/yujiaxue.png')
              } else if (text.indexOf('雪') !== -1) {
                return require('../../assets/img/newIndex/weather/xue.png')
              } else if (text.indexOf('阴') !== -1) {
                return require('../../assets/img/newIndex/weather/yin.png')
              } else if (text.indexOf('龙卷风') !== -1) {
                return require('../../assets/img/newIndex/weather/longjuanfeng.png')
              } else if (text.indexOf('雨') !== -1) {
                return require('../../assets/img/newIndex/weather/yu.png')
              } else if (text.indexOf('冰雹') !== -1) {
                return require('../../assets/img/newIndex/weather/bingbao.png')
              } else if (text.indexOf('沙尘') !== -1) {
                return require('../../assets/img/newIndex/weather/shachen.png')
              } else if (text.indexOf('多云') !== -1) {
                return require('../../assets/img/newIndex/weather/yun.png')
              } else {
                 return require('../../assets/img/newIndex/weather/yin.png')
              }
            }
        },
        created() {
            this.getWeather()
            this.getXuanType()
            // 获取热门信息
            this.getXuanInfo(4, 10)
            // 获取海钓活动活动
            this.getXuanInfo(2, 6)
            this.getSeeType()
            // 海钓视频
            this.getSeeInfo(1, 9)
            // 海钓渔获
            this.getSeeInfo(8, 6)
             // 海钓咨询
            this.getXuanInfo(1, 3)
            this.getRecommend()
            this.addListenEventBus()
             // 海钓常识
            this.getXuanInfo(3, 6)
        },
        mounted() {
            let _that = this
            // 设置banenr 高度
            this.$refs.img[0].onload = function() {
              _that.carHeight = this.height + 'px'
            }
        }
    }
</script>

<style scoped lang="less">
@import "../../assets/less/variable";
.ellipsis-class {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more {
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #093e5f;
  border-radius: 2px;
  color: #093e5f;
  font-size: 16px;
  margin: 0 auto;
  cursor: pointer;
  a {
    color: #093e5f;
  }
}
#IndexInfo {
  width: 100%;
  min-width: 1200px;
  position: relative;
  margin-top: -100px;
  .banner {
    width: 100%;
    min-width: 1200px;
    position: relative;
    .el-carousel__item {
      img {
        width: 100%;
        height: auto;
      }
    }
    .weather {
      color: white;
      font-size: 16px;
      position: absolute;
      top: 120px;
      left: 100px;
      z-index: 2;

      .weather-header {
        height: 60px;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 35px;
        .weather-h-item {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          li {
            padding: 0 30px;
            position: relative;
            line-height: 30px;
            .loc-ico {
              margin-right: 9px;
            }
            .star-list {
              margin-left: 10px;
            }
            img {
              height: 24px;
              margin-bottom: 3px;
            }
            &:first-child {
              padding-right: 10px;
            }
            &::before {
              content: "";
              position: absolute;
              right: 0;
              top: 0;
              height: 30px;
              width: 1px;
              background: #7a7a7a;
            }
            &:last-child::before {
              height: 0;
            }
          }
        }
      }
    }
    .hot-info {
      position: absolute;
      right: 100px;
      top: 24.1%;
      height: 55.5%;
      background: rgba(0, 0, 0, 0.4);
      width: 600px;
      z-index: 10;
      color: #fff;
      padding: 40px 65px 57px;
      box-sizing: border-box;
      font-size: 20px;
      h3 {
        text-align: center;
        font-size: 32px;
        margin-bottom: 11px;
      }

      .hot-info-box {
        overflow: hidden;
      }
      .hot-info-list {
        margin-top: 26px;
        padding-left: 20px;
        position: relative;
        .ellipsis-class;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #fff;
        }
      }
    }
  }

  .index-content {
    .com-header {
      text-align: center;
      margin-bottom: 90px;
      img {
        height: 110px;
      }
    }
    .sea-fishing {
      margin-top: 70px;
      .sea-con {
        font-size: 0;
        width: 1070px;
        margin: 0 auto;
      }
      .sea-con-list {
        display: inline-block;
        font-size: 36px;
        margin-right: 130px;
        margin-bottom: 71px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        img {
          width: 270px;
          height: 270px;
          border-radius: 50%;
          object-fit: cover;
        }
        .sea-con-list-title {
          width: 270px;
          text-align: center;
          line-height: 36px;
          color: #7e7f7f;
          margin-top: 30px;
          .ellipsis-class;
        }
      }
    }
    .sea-video {
      margin-top: 107px;
      // background: url(../../assets/img/newIndex/video-bg.jpg) no-repeat top;
      .sea-video-header {
        text-align: center;
        img {
          height: 150px;
        }
        margin-bottom: 70px;
      }
      .play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        cursor: pointer;
      }
      .sea-video-con {
        font-size: 0;
        .sea-video-con-left,
        .sea-video-con-right {
          width: 50%;
          display: inline-block;
          height: 740px;
          vertical-align: top;
          position: relative;

          &.sea-video-con-left .play-btn {
            width: 200px;
            height: 200px;
          }
          &.sea-video-con-right .play-btn {
            width: 80px;
            height: 80px;
          }
        }
        .sea-video-con-left video {
          width: 100%;
          object-fit: fill;
          height: 100%;
        }
        .video-more {
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
          span {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 36px;
            color: #fff;
          }
        }
        .sea-video-con-right .sea-video-con-box,
        .video-more {
          width: 33.3%;
          height: 33.3%;
          object-fit: fill;
          vertical-align: top;
          display: inline-block;
          position: relative;
        }
        .sea-video-con-right video {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
        .sea-video-bottom {
          width: 100%;
          height: 800px;
          background: url(../../assets/img/newIndex/video-bg.jpg) no-repeat;
          background-size: 100% 100%;
          display: flex;
          .sea-video-b-left,
          .sea-video-b-right {
            vertical-align: top;
            width: 50%;
            height: 600px;
            font-size: 16px;
            color: #404040;
            line-height: 28px;
            display: flex;
            align-items: center;
            position: relative;
            .sea-video-b-c {
              width: 67%;
              margin: 0 auto;
              h3 {
                font-size: 53px;
                color: #000;
                margin-bottom: 30px;
              }
              text-indent: 40px;
            }
            .sea-video-b-right-b {
              position: relative;
              height: 300px;
              width: 75%;
            }
            video {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
    .sea-get {
      margin-top: 70px;
      .sea-get-con {
        font-size: 0;
        width: 1200px;
        margin: 0 auto;
        .sea-get-list {
          display: inline-block;
          padding-right: 24px;
          margin-bottom: 70px;
          width: 33.3%;
          box-sizing: border-box;
          &:nth-child(3n) {
            padding-right: 0;
          }
          img {
            width: 100%;
            height: 330px;
            object-fit: cover;
          }
          .sea-con-list-title {
            width: 100%;
            line-height: 46px;
            height: 92px;
            overflow: hidden;
            font-size: 36px;
            color: #000;
            margin-top: 30px;
          }
        }
      }
      .more {
        margin-bottom: 30px;
      }
    }
    .sea-advisory {
      background: url(../../assets/img/newIndex/advisory-bg.png) center
        no-repeat;
      background-size: 100% 100%;
      height: 668px;
      .sea-advisory-header {
        text-align: center;
        margin-top: 100px;
        margin-bottom: 88px;
        img {
          width: 300px;
          height: 110px;
        }
      }
      .sea-advisory-con {
        display: flex;
        width: 1200px;
        margin: 0 auto;
        .sea-advisory-left {
          width: 780px;
          height: 280px;
          margin-right: 40px;
          .sea-advisory-left-list {
            display: flex;
            width: 100%;
            float: right;
            border: 1px solid #ebebeb;
            padding: 8px 0 5px;
            margin-bottom: 5px;
            position: relative;
            .sea-list-date {
              margin-right: 17px;
              .sea-date-com {
                width: 90px;
                height: 36px;
                line-height: 36px;
                color: #fff;
                text-align: center;
                &.sea-date-month {
                  background: #003f62;
                }
                &.sea-date-date {
                  background: #74c5ff;
                }
              }
            }
            .sea-list-content {
              font-size: 16px;
              color: #404040;
              line-height: 26px;
              height: 78px;
              overflow: hidden;
            }
            .sea-list-btn {
              width: 20px;
              height: 90px;
              text-align: center;
              line-height: 90px;
              font-size: 10px;
              background: #74c5ff;
              position: absolute;
              top: -1px;
              right: -20px;
            }
          }
        }
        .sea-advisory-right {
          width: 520px;
          height: 280px;
          img {
            width: 520px;
            height: 280px;
          }
        }
      }
      .more {
        margin-top: 88px;
      }
    }
  }

  .sea-sense {
    height: 400px;
    background: #ececec;
    padding-top: 40px;
    box-sizing: border-box;
    h3 {
      font-size: 32px;
      display: inline-block;
    }
    .line {
      background: #093e5f;
      height: 2px;
      width: 128px;
      margin-top: 11px;
      margin-bottom: 39px;
    }
    .sea-sense-con {
      width: 1200px;
      margin: 0 auto;
      .more {
        margin-top: 30px;
        border: 0;
        margin-left: 0;
        text-align: left;
      }
      .sea-sense-con-list {
        font-size: 16px;
        color: #404040;
        line-height: 32px;
        height: 32px;
        .sea-sense-title {
          width: 600px;
          float: left;
          .ellipsis-class;
        }
        .sea-sense-time {
          float: right;
        }
      }
    }
  }
  footer {
    width: 100%;
    min-width: 1200px;
    height: 140px;
    margin-top: 60px;
    background: rgba(51, 51, 51, 1);
    color: #999;

    > .footer-box {
      width: 1200px;
      margin: 0 auto;
      padding-top: 30px;
      box-sizing: border-box;

      .friendship {
        display: flex;
        justify-content: center;

        > div {
          margin-left: 20px;
          cursor: pointer;

          &:hover {
            color: rgba(5, 160, 130, 1);
          }

          > span {
            margin-left: 20px;
          }
        }
      }

      > p {
        text-align: center;

        &:nth-of-type(1) {
          margin-top: 30px;
        }

        &:nth-of-type(2) {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.weath-class {
  height: 420px;
  width: 630px;
  background: rgba(0, 0, 0, 0.4)!important;
  border-radius: 10px!important;
  border: 0!important;;
  padding: 0!important;;
  line-height: 1!important;;
  color: #000!important;;
  .weather-con {
    display: flex;
    justify-content: space-between;
    padding: 40px;
    box-sizing: border-box;
    height: 100%;
    .weather-con-list {
      text-align: center;
      flex: 1;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 10px;
      margin-right: 20px;
      font-size: 24px;
      &:last-child {
        margin-right: 0;
      }
      .weather-name,
      .weather-date {
        margin-top: 26px;
      }
      .weather-ico {
        margin-top: 24px;
      }
      .weather-text {
        margin-top: 12px;
      }
      .weather-tem {
        margin-top: 34px;
        color: #f63232;
      }
      .weather-wind {
        margin-top: 30px;
        font-size: 22px;
      }
    }
  }
}
.el-scrollbar__wrap {
  overflow-x: hidden!important;
}
</style>



// WEBPACK FOOTER //
// src/views/index-info/IndexInfo.vue